export default __webpack_public_path__ + "static/media/simpleinspect2.8554e5c3.png";